"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExportErrorHtml = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
const ExportErrorHtml = ({
  errorCode,
  url,
  occurredAt,
  errors,
  operationId,
  operationTraceLink,
  developmentInfo
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
    children: "Extended Error Info"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
    children: "Basic Info"
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
      children: ["Page URL: ", url]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
      children: ["Page Error Code: ", errorCode]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
      children: ["Error Occurred At: ", occurredAt]
    }), developmentInfo?.teamName ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
      children: ["Page Owner: ", developmentInfo.teamName]
    }) : null, operationId != null && operationTraceLink ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
      children: ["View Operation Trace: ", /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        href: operationTraceLink,
        children: operationId
      })]
    }) : null]
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      marginTop: '2rem'
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
      children: "Errors"
    }), errors.map((error, index) =>
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key -- immutable array, index is safe
    (0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h3", {
        children: [index === 0 ? 'Top-Level Error' : 'Caused By', ": [", error.name, "]", ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: 'red'
          },
          children: error.message
        })]
      }), error.stack ? /*#__PURE__*/(0, _jsxRuntime.jsx)("pre", {
        children: error.stack
      }) : null, error.fetchInfo ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
          children: "Fetch Info:"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("pre", {
          children: JSON.stringify(error.fetchInfo, null, 2)
        })]
      }) : null]
    }, index))]
  }), developmentInfo ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      marginTop: '2rem'
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
      children: "App Info"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("table", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
        children: Object.entries(developmentInfo).map(([key, value]) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("tr", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("td", {
            children: [key, ":"]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
            children: value
          })]
        }, key))
      })
    })]
  }) : null]
});
exports.ExportErrorHtml = ExportErrorHtml;
